<template>
  <template v-for="postRoot in postTree" :key="postRoot.id">
    <ul class="anz-posts">
      <post-list-branch
        :post-root="postRoot"
        open-respond-page
        strip-long-text
        disable-advert
      ></post-list-branch>
    </ul>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import usePostsLoader from '@/composables/post/postLoader'
import PostListBranch from '@/components/Post/PostListBranch.vue'

export default defineComponent({
  name: 'PostTopNewestList',
  components: { PostListBranch },
  async setup() {
    const { postTree, loadNext, clearListData, addPost } = usePostsLoader()

    clearListData()
    loadNext()

    return {
      postTree,
      addPost,
    }
  },
})
</script>
